import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiFirmRoute } from "@/lib/data/requests/firm/firm";
import type {
  APIResponse,
  LawWorksCharge,
  LawWorksChargeQuery,
} from "@/lib/types";

export const retrieveFirmLawWorksCharges = (params: LawWorksChargeQuery = {}) =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<LawWorksCharge[]>>(`${baseFastApiFirmRoute}/charges`, {
      params,
    })
    .then((res) => res.data);
